<template>
  <div id="app">
        <!-- <div id="nav">
            <router-link v-if="authenticated" to="login" v-on:click.native="logout()" replace>Logout</router-link>
        </div> -->
        <router-view @authenticated="setAuthenticated" />
        <!-- <footer class="footer">
            <div>&copy; {{ new Date().getFullYear() }}</div>
            <router-link v-if="authenticated" to="login" v-on:click.native="logout()" replace>Logout</router-link>
        </footer> -->
    </div>
</template>

<script>
export default {
        name: 'App',
        data() {
            return {
                authenticated: false
            }
        },
        methods: {
            setAuthenticated(status) {
                this.authenticated = status;
            },
            logout() {
                localStorage.clear();
                this.authenticated = false;
            }
        }
    }
</script>

<style lang="sass" src="bulma"></style>
<style lang="sass">
  $fa-font-path: '../node_modules/font-awesome/fonts/';
  @import '../node_modules/font-awesome/scss/font-awesome';
</style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
#app{
  font-family: 'Poppins','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #d923d3;
  /* background-color: #F2F4F8; */
  background-color: #FFFFFF;
}
body, button, input, h1, h2, h3 {
  font-family: 'Poppins','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue